export default {"src":"/_next/static/media/heart.2f5f7943.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};